






























import { Prop, Model, Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TileComponentMixin from '@/mixins/TileComponentMixin';
import { BModal } from 'bootstrap-vue';
import _ from 'lodash';
import { N2KFluidLevelEventType, IN2KFluidLevelEvent } from '@/common/apis/DeviceApi';
import { RadialGauge } from 'canvas-gauges';
import UserMixin from '@/mixins/UserMixin';

export interface IBaseFluidConfiguration { }

@Component({
    components: {
    },
})
export default class BaseFluidTile extends Mixins(TileComponentMixin, UserMixin) {
    @Prop({required: false})
    public configuration?: IBaseFluidConfiguration;

    @Prop({required: true})
    public pickerTitle: string;

    @Prop({required: true})
    public header: string;

    @Prop({required: true})
    public type: N2KFluidLevelEventType;

    @Prop({required: true})
    public options: CanvasGauges.RadialGaugeOptions;

    public editConfiguration: IBaseFluidConfiguration | null = null;

    public get available(): boolean {
        if (this.isPicker && !this.lastEvent) {
            return false;
        }
        return true;
    }


    public get lastEvent(): IN2KFluidLevelEvent | null {
        let fluid = this.getFluid(this.deviceNumber, this.type);
        if (!fluid && this.isDemo) {
            fluid = this.demoData || null;
        }
        return fluid;
    }

    public get ageInSeconds(): number {
        if (this.lastEvent && this.lastEvent.timestamp) {
            const timestamp = typeof this.lastEvent.timestamp === 'object'
                ? this.lastEvent.timestamp
                : new Date(this.lastEvent.timestamp);

            return (new Date().getDate() - timestamp.getDate()) / 1000;
        }
        return 999;
    }

    private chart?: RadialGauge;
    private chartOptions?: CanvasGauges.RadialGaugeOptions;
    private demoData: IN2KFluidLevelEvent | null = null;
    private demoDataInterval: number;
    private redrawCount: number = 0;


    @Getter('n2k/fluid')
    private getFluid: (deviceNumber: string, type: N2KFluidLevelEventType) => IN2KFluidLevelEvent | null;

    public save() {
        this.$emit('save', this.editConfiguration);
    }

    // public onClick() {
    //     if (this.isEditing && this.configuration) {
    //         this.$emit('save', this.editConfiguration);
    //         // this.editConfiguration = _.cloneDeep(this.configuration);
    //         // (this.$refs.configurator as BModal).show();
    //     }
    // }

    public async mounted() {
        if (this.isDemo) {
            this.generateDemoData();
            this.demoDataInterval = setInterval(this.generateDemoData, 1000);
        }
        if (this.isPicker) {
            this.editConfiguration = {
                name: '',
            };
        } else {
            this.chartOptions = this.options;
            this.chartOptions.renderTo = this.$refs.canvas as HTMLElement;

            if (this.chartOptions && this.lastEvent && this.lastEvent.level !== undefined) {
                this.chartOptions.value = this.lastEvent.level;
            }

            this.chart = new RadialGauge(_.cloneDeep(this.chartOptions)).draw();
        }
    }
    public async beforeDestroy() {
        clearInterval(this.demoDataInterval);
        if (this.chart && this.chartOptions) {
            this.chart.destroy();
        }
    }



    @Watch('lastEvent')
    public updateChartValue() {
        if (this.chart && this.lastEvent && this.lastEvent.level !== undefined) {
            this.chart.value = this.lastEvent.level;
        }


        // Destry & Rebuild to avoid canvas crash on iOS
        this.redrawCount++;
        if (this.redrawCount > 500) {
            this.redrawCount = 0;
            if (this.chart && this.chartOptions) {
                this.chart.destroy();
                if (this.chartOptions && this.lastEvent && this.lastEvent.level !== undefined) {
                    this.chartOptions.value = this.lastEvent.level;
                }
                this.chart = new RadialGauge(_.cloneDeep(this.chartOptions)).draw();
            }
        }
    }

    private generateDemoData() {

        let level = (this.demoData ? this.demoData.level : undefined) || Math.random() * 100;

        level -= Math.random() * 0.5 * (this.type === N2KFluidLevelEventType.BlackWater ? -1 : 1);
        if (level > 100) {
            level = 0;
        }
        if (level < 0) {
            level = 100;
        }

        this.demoData = {
            type: this.type,
            level,
            capacity: 100,
            sensorNumber: 0,
            deviceNumber: this.deviceNumber,
            timestamp: new Date(),
        };
    }
}
